import { render, staticRenderFns } from "./SuperFormula.vue?vue&type=template&id=26bedd16&scoped=true"
import script from "./SuperFormula.vue?vue&type=script&lang=js"
export * from "./SuperFormula.vue?vue&type=script&lang=js"
import style0 from "./SuperFormula.vue?vue&type=style&index=0&id=26bedd16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bedd16",
  null
  
)

export default component.exports